export const christmas = () => {
  const today = new Date()
  const range = { fromDate: '11-20', toDate: '01-02' }
  // return true

  return (today >= new Date(`${today.getFullYear()}-${range.fromDate}`) && today <= new Date(`${today.getFullYear() + 1}-${range.toDate}`))
}